import { registerFailedRefreshAttempt } from "@/modules/auth/utils/refreshTokenAttempts"
import { type ApiInterceptor } from "@modules/core/api/interceptors/apiInterceptor"
import { HUError, HUErrorCode } from "@modules/error/huError"
import { type AxiosResponse, isAxiosError } from "axios"

export const responseUnauthorizeErrorInterceptor = (): ApiInterceptor<AxiosResponse> => ({
  onRejected: (error) => {
    // A request that still fails authentication after the refresh-and-retry fallback counts as a
    // failed refresh attempt. The shared counter forces a logout once the limit is reached, instead
    // of disconnecting the user on a single (possibly transient) 401.
    const isUnauthorized = isAxiosError(error) && error.response?.status === 401
    const isUnauthorizedHuError =
      error instanceof HUError &&
      // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
      (error.code === HUErrorCode.Unauthorised || error.code === HUErrorCode.TokenExpired)

    if (isUnauthorized || isUnauthorizedHuError) {
      void registerFailedRefreshAttempt()
    }

    const rejectReason = error instanceof Error ? error : new Error(String(error))
    return Promise.reject(rejectReason)
  },
})
